import React, { useState, useEffect } from 'react';

const NsfwToggle = () => {
  // Default to NSFW unless user explicitly saved SFW.
  const [isNsfw, setIsNsfw] = useState(() => {
    const saved = localStorage.getItem('nsfw_mode');
    if (saved === 'false') return false;
    if (saved === 'true') return true;
    return true;
  });

  useEffect(() => {
    // Apply mode and notify listeners (e.g., roster links) immediately.
    if (isNsfw) {
      document.body.classList.add('nsfw-mode');
      document.body.classList.remove('sfw-mode');
    } else {
      document.body.classList.add('sfw-mode');
      document.body.classList.remove('nsfw-mode');
    }
    
    localStorage.setItem('nsfw_mode', isNsfw ? 'true' : 'false');
    window.dispatchEvent(new CustomEvent('nsfw-mode-changed', { detail: isNsfw }));
  }, [isNsfw]);

  const toggleNsfw = () => {
    setIsNsfw(!isNsfw);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginRight: '10px'
      }}
    >
      <button
        type="button"
        onClick={toggleNsfw}
        role="switch"
        aria-checked={isNsfw}
        title={isNsfw ? 'Currently NSFW mode. Click to switch to SFW.' : 'Currently SFW mode. Click to switch to NSFW.'}
        style={{
          position: 'relative',
          width: '104px',
          height: '30px',
          border: '1px solid rgba(0,0,0,0.15)',
          borderRadius: '999px',
          cursor: 'pointer',
          background: isNsfw ? 'linear-gradient(90deg, #ffb8b8 0%, #ffe6e6 100%)' : 'linear-gradient(90deg, #ececec 0%, #dcdcdc 100%)',
          color: '#1f2937',
          padding: '0 9px',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '11px',
          fontWeight: 700
        }}
      >
        <span style={{ opacity: isNsfw ? 1 : 0.55, zIndex: 2 }}>NSFW</span>
        <span style={{ opacity: isNsfw ? 0.55 : 1, zIndex: 2 }}>SFW</span>
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: '3px',
            left: isNsfw ? '3px' : '51px',
            width: '50px',
            height: '24px',
            borderRadius: '999px',
            backgroundColor: isNsfw ? '#ef4444' : '#6b7280',
            boxShadow: '0 2px 6px rgba(0,0,0,0.22)',
            transition: 'left 0.2s ease, background-color 0.2s ease'
          }}
        />
      </button>
    </div>
  );
};

export default NsfwToggle;